<div class="eb-container">
  <div class="eb-wrapper">

    <!-- ── En-tête ── -->
    <div class="eb-header">
      <div class="eb-header-text">
        <h3 class="eb-title">Expression de besoin</h3>
        <p class="eb-subtitle">Gérez vos expressions de besoin et regroupements</p>
      </div>

      <div class="eb-actions">
        <app-ui-button
          label="Regrouper"
          variant="secondary"
          iconLeft="category"
          *ngIf="hasAccess(['SU', 'PRMP'])"
          [routerLink]="[
            '/',
            routealias.marchees.home,
            routealias.marchees.expression_besoin.home,
            routealias.marchees.expression_besoin.regroupement_expression_besoin.home,
            routealias.marchees.expression_besoin.regroupement_expression_besoin.add
          ]"
        />
        <app-ui-button
          label="Ajouter"
          variant="primary"
          iconLeft="add_circle_outline"
          [routerLink]="routealias.marchees.expression_besoin.add"
        />
      </div>
    </div>

    <!-- ── Tableau ── -->
    <div class="eb-table">
      <app-ui-table
        [columns]="tableExpressionBesoin"
        [data]="expressionBesoins"
        [actions]="rowActions"
      />
    </div>

  </div>
</div>

<!-- ── Actions de ligne ── -->
<ng-template #rowActions let-item="item" let-index="index">
  <div class="eb-row-actions">
    <app-ui-button
      variant="secondary"
      iconOnly="edit"
      ariaLabel="Modifier"
      [routerLink]="getEditRouterLink(item)"
    />
    <app-ui-button
      variant="danger"
      iconOnly="delete"
      ariaLabel="Supprimer"
      (clicked)="openDeleteDialog(item)"
    />
  </div>
</ng-template>

<!-- ── Boîte de dialogue de confirmation ── -->
<div
  class="cd-backdrop"
  *ngIf="deleteDialog.isVisible"
  (click)="cancelDelete()"
  aria-modal="true"
  role="dialog"
>
  <div
    class="cd-panel"
    (click)="$event.stopPropagation()"
    role="alertdialog"
    aria-labelledby="cd-title"
    aria-describedby="cd-message"
  >
    <!-- Icône -->
    <div class="cd-icon-wrap">
      <div class="cd-icon-ring cd-icon-ring--outer"></div>
      <div class="cd-icon-ring cd-icon-ring--inner"></div>
      <div class="cd-icon-circle">
        <mat-icon>delete_forever</mat-icon>
      </div>
    </div>

    <!-- Texte -->
    <div class="cd-text">
      <h2 class="cd-title" id="cd-title">Confirmer la suppression</h2>
      <p class="cd-message" id="cd-message">
        Cette action est irréversible. L'élément sera définitivement supprimé.
      </p>
      <div *ngIf="deleteDialog.itemLabel" class="cd-item-label">
        <mat-icon class="cd-item-label__icon">label</mat-icon>
        <span>{{ deleteDialog.itemLabel }}</span>
      </div>
    </div>

    <!-- Actions -->
    <div class="cd-actions">
      <button
        type="button"
        class="cd-btn cd-btn--cancel"
        (click)="cancelDelete()"
        [disabled]="deleteDialog.isLoading"
      >
        <mat-icon>close</mat-icon>
        Annuler
      </button>

      <button
        type="button"
        class="cd-btn cd-btn--confirm"
        (click)="confirmDelete()"
        [disabled]="deleteDialog.isLoading || !deleteDialog.confirmReady"
        [class.cd-btn--loading]="deleteDialog.isLoading"
        [class.cd-btn--waiting]="!deleteDialog.confirmReady && !deleteDialog.isLoading"
      >
        <ng-container *ngIf="deleteDialog.isLoading">
          <span class="cd-spinner"></span>
          Suppression…
        </ng-container>
        <ng-container *ngIf="!deleteDialog.isLoading && !deleteDialog.confirmReady">
          <span class="cd-countdown">{{ deleteDialog.countdown }}</span>
          Supprimer
        </ng-container>
        <ng-container *ngIf="!deleteDialog.isLoading && deleteDialog.confirmReady">
          <mat-icon>delete</mat-icon>
          Supprimer
        </ng-container>
      </button>
    </div>
  </div>
</div>